import { FormField, FormFieldProps } from '@workday/canvas-kit-react/form-field';
import { FieldError } from 'react-hook-form';

export type FormFieldErrorProps = Pick<FormFieldProps, 'error' | 'errorLabel' | 'hintText' | 'hintId'>;

/**
 * Creates error props for a FormField from a react hook form error object
 * @deprecated - use formFieldErrorPropsV2 instead
 */
export const formFieldErrorProps = (errors, id: string): FormFieldErrorProps => {
    const error = errors[id];

    return error
        ? {
              error: FormField.ErrorType.Error,
              hintText: error.message,
              hintId: 'error-' + id
          }
        : {};
};

/**
 * Creates error props for a FormField from a react hook form error object
 * @param error a FieldError from react-hook-form
 * @param name a name to be used if there is no ref available on the fieldError
 * @param errorLabel a name to be used with translated error prefix on the fieldError
 */
export const formFieldErrorPropsV2 = (error?: FieldError, name?: string, errorLabel?: string): FormFieldErrorProps => {
    if (!error) {
        return {};
    }

    const hintSuffix = error.ref?.name || name;

    if (!hintSuffix) {
        console.warn('No name for input so cannot generate hintId for FormField');
    }

    const hintId = hintSuffix ? { hintId: 'error-' + hintSuffix } : {};

    return {
        error: FormField.ErrorType.Error,
        errorLabel: errorLabel,
        hintText: error.message,
        ...hintId
    };
};
